import { PaymentsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/payment-wrapper';

export function DinersClubIcon(props: PaymentsProps) {
  return (
    <SvgWrapper {...props}>
      <g fill="none" fillRule="evenodd">
        <rect
          x={0.5}
          y={0.5}
          width={35}
          height={23}
          rx={4}
          fill="#FFF"
          stroke="#CFD4D9"
        />
        <path
          d="M19.36 6c3.46-.001 6.618 2.603 6.618 6.37 0 3.446-3.158 6.278-6.618 6.262h-2.977C12.882 18.648 10 15.817 10 12.37 10 8.604 12.882 5.999 16.383 6Zm-2.963.522a5.788 5.788 0 0 0-5.793 5.783 5.788 5.788 0 0 0 5.793 5.781c3.2 0 5.793-2.588 5.793-5.781a5.789 5.789 0 0 0-5.793-5.783Zm1.314 2.362a3.668 3.668 0 0 1 2.358 3.42 3.67 3.67 0 0 1-2.358 3.421V8.884Zm-2.629 0v6.84a3.67 3.67 0 0 1-2.357-3.42 3.671 3.671 0 0 1 2.357-3.42Z"
          fill="#006095"
          fillRule="nonzero"
        />
      </g>
    </SvgWrapper>
  );
}
